import React, {useState, useEffect, useContext} from "react";
import {useLocation, useNavigate, Link} from "react-router-dom";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { json } from "stream/consumers";
import Footer from "../shared/Footer";
import axios from "axios";
import {encode} from '../API/APICalls';
import {Buffer} from 'buffer';

export default function HomePage({handleClick}:any) {

  document.title = 'Get a Handicap';

    const navigate = useNavigate();
    const {state} = useLocation();

  
    const [formData, setFormData] = useState({
      zipcode : state? state : "",
      mode: ""
  });


    const handleChange = (event:React.ChangeEvent<HTMLInputElement>) => { 
      const {name, value} = event.target;
      setFormData({ ...formData, [name]: value });
      //navigate(".", {state:value});
      
    }

    const handleChangeRadio = (event:React.ChangeEvent<HTMLInputElement>) => { 
      //event.preventDefault();
      const {name, value} = event.target;
      //console.log("mode " + value);
      setFormData({ ...formData, "mode": value });
      
    }

    useEffect(() => {
      sessionStorage.removeItem("data");
      sessionStorage.removeItem("basket");
      sessionStorage.removeItem("aga");
      sessionStorage.removeItem("person");
      sessionStorage.removeItem("golfer");
      setFormData({ ...formData, "mode": "signup" });
      handleClick(JSON.parse(sessionStorage.getItem("basket") || '0'));
  
   

    }, []);
  
  
    
    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      //sessionStorage.setItem("data", JSON.stringify(formData));
      navigate('/register', {state: {zipcode: formData.zipcode, mode: formData.mode, aga: ''}});
   
  
    }

    return (<>

    <div className="container-fluid grey col-xl-12 col-xxl-12">
      <div className="container">
        <div className="row pt-5 pb-4">
              <div className="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-5 col-xxl-5">
                <form className="p-4 p-md-5 border rounded-3 bg-body-white" onSubmit={handleSubmit} id="hp-card">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"><h1>Get a Handicap Index&reg;</h1></div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"><label className="pt-3">Billing Zip Code<sup><i className="bi bi-info-circle" data-tooltip-id="zipcode-tooltip"></i></sup></label></div>
                  <div className="mb-3">
                      <input type="text" name="zipcode" className="form-control form-control-lg" id="zip" aria-describedby="zip" onChange={handleChange} value={formData.zipcode}  pattern="[0-9]*" minLength={5} maxLength={5} required onInvalid={(e) =>
    e.currentTarget.setCustomValidity('Use the ZIP Code and address associated with your credit card.')
  } onInput={(e) => e.currentTarget.setCustomValidity('')}
/>
                      <ReactTooltip
                              id="zipcode-tooltip"
                              place="top"
                              content="Please use the ZIP Code and address linked to your credit card."
                            />
                      <div className="pt-3">
                        <span className="fs-6">You’ll become a member of the Allied Golf Association (AGA) that serves your area.</span>
                      </div>
                  </div>
                  <button className="w-100 btn btn-lg btn-primary rounded-pill" type="submit">GET STARTED</button>
                </form>
                {/* <div className="row pt-4 pb-4">
                  <div className="col-12 col-sm-5 col-md-5 text-center">Already a member of the <br />GC community?</div>
                  <div className="col-12 col-sm-7 mt-1"><Link to="/membership/login" className="w-100 btn btn py-2 px-4 btn-outline-primary rounded-pill" type="submit">MANAGE MEMBERSHIP</Link></div>
                </div> */}
              </div>
              
              <div className="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-7 col-xxl-7" id="join_frame">
                <div className="row pt-1">
                  <div className="text-start"><h2>Play with anyone, anywhere!</h2></div>
                </div>
                <div className="col-12 col-sm-3">
                  <hr className="small_hr my-3"/>
                </div>
                <div className="row col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 pb-4">
                  <h3>A  Handicap Index&reg; is the trusted measure of a golfer’s ability, designed to help golfers compete fairly, track their progress, and enhance their enjoyment of the game.</h3>
                </div>
              </div>
        </div>
      </div>

      {/*NEW section*/}
      <div className="container-fluid bg-white">
        <div className="container py-5">
            <div className="row py-4">
            <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6" id="benefits_frame">
                  <div className="d-flex align-items-start">
                    <div className="fs-4 flex-shrink-0 me-3">
                      <i className="bi bi-graph-up-arrow fs-4 pe-2"></i>
                    </div>
                    <div>
                      <h3>Record your scores to track milestones, progress, and performance.</h3>
                    </div>
                  </div>

                  <div className="d-flex align-items-start pt-4">
                    <div className="fs-4 flex-shrink-0 me-3">
                    <i className="bi bi-trophy-fill fs-3 pe-2"></i>
                    </div>
                    <div className="pe-3">
                      <h3>A Handicap Index connects you with golfers around the world who share a passion for the game.</h3>
                    </div>
                  </div>

                  <div className="d-flex align-items-start pt-4 pb-5">
                    <div className="fs-4 flex-shrink-0 me-3">
                    <i className="bi bi-flag-fill fs-3 pe-2"></i>
                    </div>
                    <div className="pe-3">
                      <h3>Elevate your game by playing in local events or by creating your own competitions with friends.</h3>
                    </div>
                  </div>
                </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
              <div className="ratio ratio-16x9 text-center">
              <iframe className="embed-responsive-item" width="560" height="315" src="https://www.youtube.com/embed/SsxN_52z5Bw?si=BiNXDpJc56mJidxx&amp;start=1" title="USGA Handicap Index" allowFullScreen></iframe>
              </div>
              </div>
            </div>
            <div className="row py-4">
              <div className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 col-xxl-4 card border-0">
                <div className="col-12 bg-light border-red" id="card">
                  <div className="row text-primary-emphasis"><i className="bi bi-calendar-check-fill fs-1"></i></div>
                  <h3>How quickly can I get one?</h3>
                  <p>Your Handicap Index is calculated the day after you have posted scores from 54-holes to your scoring record made up of any combination of 9- or 18-hole rounds.</p>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 col-xxl-4 card border-0">
                <div className="col-12 bg-light border-middle" id="card">
                  <div className="row text-primary-emphasis"><i className="bi bi-calculator-fill fs-1 pe-2"></i></div>
                  <h3>How is it calculated?</h3>
                  <p>It is calculated the same way around the world, using Course Rating&trade; and Slope Rating&trade;:  your best  8 Score Differentials&trade; from your most recent 20 scores are averaged  for your Handicap Index.</p>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 col-xxl-4">
                <div className="col-12 bg-light border-gold"  id="card">
                  <div className="row text-primary-emphasis"><i className="bi bi-bar-chart-fill fs-1 pe-2"></i></div>
                  <h3>Don’t I have to be good to sign up?</h3>
                  <p>All playing abilities are welcome.  A Handicap Index delivers benefits for golfers of all skill levels.</p>
                </div>
              </div>
           </div>
        </div>
      </div>

      {/*final section*/}
      <div className="container-fluid grey">
        <div className="container">
          <div className="row py-5">
            <div className='col-12 col-sm-12 col-md-12 col-lg-10 mx-auto text-center py-5'>
              <h2 className="fs-2">The USGA is proud to work with each AGA across the United States.</h2>         
              <div className="row pt-4">
                <div className="col-12 col-sm-6 mt-1 pb-2 order-lg-1 mx-auto"><Link to="http://gcsupport.usga.org/faq" target="_blank" className="w-100 btn btn py-2 px-4 btn-primary rounded-pill" type="submit">GC FAQs</Link></div>
              </div>
            
            </div>
          </div>
        </div>
      </div>
    </div>
    </>

    )
}